module.exports = __webpack_public_path__ + "static/media/logout.326bcec9.png";